"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("@package/moment"));

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var validate = function validate(values) {
  var errors = {};

  if (values['dateFrom'] && values['dateTo']) {
    var dateFrom = (0, _moment["default"])(values['dateFrom']);
    var dateTo = (0, _moment["default"])(values['dateTo']);

    if ((0, _moment["default"])(dateFrom).isAfter(dateTo)) {
      errors['dateTo'] = 'Неверное значение';
    }
  }

  if (values['amountFrom'] && !/^\d+(\.\d{1,2})?$/.test(values['amountFrom'])) {
    errors['amountFrom'] = 'Неверный формат';
  }

  if (values['amountTo'] && !/^\d+(\.\d{1,2})?$/.test(values['amountTo'])) {
    errors['amountTo'] = 'Неверный формат';
  }

  if (values['amountFrom'] && values['amountTo']) {
    if (Number(values['amountTo']) < Number(values['amountFrom'])) {
      errors['amountTo'] = 'Неверное значение';
    }
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: 'invoices-filter',
  enableReinitialize: true,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;